import constantes from '../helpers/constanteHelper'

import { Link } from 'react-router-dom'

import Image from "react-bootstrap/Image";

import produtoDefault from '../images/produto-default.png'

function CardOutraCertificacao({ nome, urlImagem, link, resolucaoMobile }) {

    return (
        <div key={nome} className='animate__animated animate__fadeIn flex-column d-flex align-items-center justify-content-start' style={{ marginBottom: resolucaoMobile ? '20px' : '0px', cursor: 'default', width: resolucaoMobile ? '110px' : '173px', height: resolucaoMobile ? '170px' : '270px', borderRadius: '20px' }}>
            {link ? <Link style={{ textDecoration: 'none' }} to={link} target='_blank' rel='noopener noreferrer'>
                <div className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center' style={{ cursor: 'pointer', width: resolucaoMobile ? '110px' : '173px', height: resolucaoMobile ? '120px' : '180px', background: constantes.CORES.BRANCO_PADRAO, borderRadius: '20px' }}>
                    <Image style={{ height: resolucaoMobile ? '150px' : '180px', objectFit: 'contain', padding: '20px' }} src={urlImagem ? urlImagem : produtoDefault} alt="logo" fluid />
                </div>
            </Link> : <div className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center' style={{ cursor: 'default', width: resolucaoMobile ? '110px' : '173px', height: resolucaoMobile ? '120px' : '180px', background: constantes.CORES.BRANCO_PADRAO, borderRadius: '20px' }}>
                <Image style={{ height: resolucaoMobile ? '150px' : '180px', objectFit: 'contain', padding: '20px' }} src={urlImagem ? urlImagem : produtoDefault} alt="logo" fluid />
            </div>}


            <span className='mt-3' style={{ cursor: 'default', fontSize: resolucaoMobile ? '14px' : '18px', textAlign: 'center', color: constantes.CORES.BRANCO_PADRAO }}>{nome}</span>

        </div>
    );
}
export default CardOutraCertificacao;
